'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var shouldRefetch = _I18n2.default.locale !== previousLocale;
  previousLocale = _I18n2.default.locale;

  if (!options || shouldRefetch) {
    options = (0, _hubspotTimezoneUtilsUtils4.default)((0, _hubspotTimezoneUtilsUtils2.default)());
    optionsMap = options.reduce(function (accI, optionGroup) {
      return optionGroup.options.reduce(function (accJ, option) {
        accJ[option.value] = option.text;
        return accJ;
      }, accI);
    }, {});
  }
  return {
    options: options,
    optionsMap: optionsMap
  };
};

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _hubspotTimezoneUtilsUtils = require('hubspot.timezone-utils.utils.getTranslatedTimezoneGroups');

var _hubspotTimezoneUtilsUtils2 = _interopRequireDefault(_hubspotTimezoneUtilsUtils);

var _hubspotTimezoneUtilsUtils3 = require('hubspot.timezone-utils.utils.groupsToSelectOpts');

var _hubspotTimezoneUtilsUtils4 = _interopRequireDefault(_hubspotTimezoneUtilsUtils3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var previousLocale = void 0;
var options = void 0;
var optionsMap = void 0;

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/utils/getTimezoneOptions.js
// module id = 471
// module chunks = 0